// eosManuals.js
export const eosManuals = {
  "ma400": {
    title: "Bộ Điều Khiển 4 Motor MA400 (MA400 Four AC Motors Controller)",
    protocol: "Nguồn: 100-230VAC | Tải max: 250W/Motor | Sóng: Phải gắn QF-Plugin",
    buttons: [
      "Đèn POW: Đáo báo có nguồn điện.",
      "Đèn BUS: Báo trạng thái tín hiệu mạng thông minh.",
      "Đèn ACT: Đèn báo đang hoạt động (Active).",
      "Lưu ý cắm chốt: Cổng số 41 (Program) chính là cổng cấp nguồn DC 5V cho cục thu sóng QF-Plugin."
    ],
    pairing: [
      "⚠️ CẢNH BÁO CÀI ĐẶT MẠNG (HDi BUS):",
      "Quy tắc ID (Rất quan trọng): Địa chỉ ID đầu tiên của hộp MA400 BẮT BUỘC phải là BỘI SỐ CỦA 4 (VD: 0, 4, 8, 12, 16...). Hộp sẽ tự động tạo 3 số ID tiếp theo cho 3 motor còn lại.",
      "Đi dây mạng: Phải đi theo kiểu nối tiếp (Daisy chain A qua A, B qua B).",
      "Điện trở chốt: Bắt buộc phải kẹp điện trở 120-ohm (1/4W) ở 2 đầu cuối cùng của đường dây mạng.",
      "Siết ốc vừa tay: Khu vực điện 220V (Pin 1-22) siết tối đa 0.4Nm. Khu vực tín hiệu (Pin 23-46) siết tối đa 0.2Nm để tránh nát bo mạch."
    ]
  },
  
  "qa200": {
    title: "Bộ Thu Tín Hiệu 2 Motor QA200 (QA200 Receiver)",
    protocol: "Tải tối đa: 350W x 2 - Sóng: QRF (433MHz)",
    buttons: [
      "Nút SET: Dùng để Ghép đôi (Đè 3 giây), Xóa kênh, hoặc Đổi chế độ (Đè 8 giây).",
      "Đèn Xanh Lá (Green): Báo hiệu đang thao tác cài đặt với Motor 1.",
      "Đèn Đỏ (Red): Báo hiệu đang thao tác cài đặt với Motor 2.",
      "Đèn Cam (Orange): Báo hiệu đang trong Cài đặt Chế độ (Mode Setting)."
    ],
    pairing: [
      "GHÉP ĐÔI MOTOR 1: Đè nút SET 3 giây tới khi đèn sáng XANH LÁ rồi nhả tay ra. Bấm nút LÊN (△) trên remote. Đèn chớp 3 lần rồi tắt là xong.",
      "GHÉP ĐÔI MOTOR 2: Đè nút SET 3 giây tới khi đèn sáng XANH LÁ. Bấm nhả nút SET thêm 1 cái để đèn chuyển sang ĐỎ. Bấm nút LÊN (△) trên remote. Đèn chớp tắt là xong.",
      "XÓA KÊNH (UNPAIR): Làm y như bước ghép đôi (vào đèn Xanh Lá hoặc Đỏ). Nhưng thay vì bấm Lên, hãy bấm nút XUỐNG (▽) trên remote để xóa.",
      "--- CÀI ĐẶT CHẾ ĐỘ (MODE SETTING) ---",
      "Vào chế độ cài đặt: Đè nút SET 8 giây liên tục cho đến khi đèn sáng màu CAM. Dùng công tắc SQ-2 để chọn các Mode sau:",
      "Mode 1 (Roller Group - Rèm cuốn chạy gộp): Bấm nút LÊN bên PHẢI (Ch2 Up). Cấp điện liên tục.",
      "Mode 2 (Roller Individual - Rèm cuốn chạy độc lập): Bấm nút LÊN bên TRÁI (Ch1 Up). Cấp điện liên tục.",
      "Mode 3 (VB Group - Rèm sáo chạy gộp): Bấm nút XUỐNG bên PHẢI (Ch2 Down). Chạm nhả để lật lá rèm, đè 3 giây để kéo rèm.",
      "Mode 4 (VB Individual - Rèm sáo chạy độc lập): Bấm nút XUỐNG bên TRÁI (Ch1 Down). Chạm nhả để lật lá rèm, đè 3 giây để kéo rèm.",
      "Mode 5 (Combine - Rèm cuốn + Rèm sáo): Bấm nút 'Mode 5' ẩn. Motor 1 chạy cuốn, Motor 2 chạy sáo."
    ]
  },

  "tq-4": {
    title: "Remote 4 Kênh TQ-4 (TQ-4 Four-Channel Transmitter)",
    protocol: "Sóng: QRF (433MHz FSK)",
    buttons: [
      "Nút Tròn Phải (O): Chuyển Kênh (1, 2, 3, 4, hoặc TẤT CẢ).",
      "Tam Giác Trên (△): LÊN / Mở.",
      "Tam Giác Dưới (▽): XUỐNG / Đóng.",
      "Hình Vuông Trái (□): DỪNG.",
      "Mẹo (chỉ cho MA400): Đè nút DỪNG để chạy tới vị trí nhớ sẵn (preset)."
    ],
    pairing: [
      "Bấm nút Tròn (O) trên remote để chọn kênh muốn xài.",
      "Đè nút SET trên cục QA200 hoặc QF-Plugin tầm 3 giây. Đèn LED sẽ sáng lên.",
      "Bấm nút LÊN (△) trên remote TQ-4 để Ghép Đôi.",
      "Bấm nút XUỐNG (▽) trên remote TQ-4 để Xóa Kênh (Unpair)."
    ]
  },
  
  "sq-2": {
    title: "Công Tắc Không Dây SQ-2 (SQ-2 Wireless Switch)",
    protocol: "Sóng: QRF (433MHz) - Tự phát điện (Không xài pin)",
    buttons: [
      "Tam Giác Trên (△): LÊN / Mở (Bấm 1 phát chạy, bấm phát nữa DỪNG).",
      "Tam Giác Dưới (▽): XUỐNG / Đóng (Bấm 1 phát chạy, bấm phát nữa DỪNG).",
      "Lưu ý: KHÔNG dán lên vách kim loại hay kính cường lực vì sẽ làm nhiễu sóng."
    ],
    pairing: [
      "Đè nút SET trên cục thu (QA200, QF-Plugin...) tầm 3 giây đến khi đèn sáng xanh rồi nhả tay ra.",
      "Trong vòng 10 giây, bấm nút LÊN (△) trên công tắc SQ-2 để Ghép Đôi.",
      "Trong vòng 10 giây, bấm nút XUỐNG (▽) trên công tắc SQ-2 để Xóa Kênh (Unpair)."
    ]
  }
};